import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageModalData } from '../../../models/shared/message-modal-data.model';

@Component({
    selector: 'app-confirm-delete-modal',
    templateUrl: './message-modal.component.html',
    styleUrls: ['./message-modal.component.scss']
})
export class MessageModalComponent {
    constructor(
        private dynamicDialogConfig: DynamicDialogConfig,
        private ref: DynamicDialogRef
    ) {}

    data: MessageModalData = this.dynamicDialogConfig.data;

    close(action: string) {
        this.ref.close(action);
    }
}
